import React from 'react';
import { Provider } from "react-redux";
import ReactDOM from 'react-dom/client';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from "react-i18next";
import i18n from './components/i18next/i18n';
import store from "./store";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<Provider store={store}>
  
  <React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <App />
   
    </I18nextProvider>
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
